import { Accordion, AccordionTab } from "primereact/accordion"
import DemographicsContainer from "../Containers/DemographicsContainer"
import { INTERVIEW_TYPES } from "../types/interviewTypes"
import PlannedServices1Container from "../Containers/PlannedServices1Container"
import PlannedServices2Container from "../Containers/PlannedServices2Container"
import PlannedServices3Container from "../Containers/PlannedServices3Container"
import PlannedServices4Container from "../Containers/PlannedServices4Container"
import SubstanceUse1Container from "../Containers/SubstanceUse1Container"
import SubstanceUse2Container from "../Containers/SubstanceUse2Container"
import SubstanceUse3Container from "../Containers/SubstanceUse3Container"
import FamilyContainer from "../Containers/FamilyContainer"
import EducationContainer from "../Containers/EducationContainer"
import LegalContainer from "../Containers/LegalContainer"
import MentalContainer from "../Containers/MentalContainer"
import SocialContainer from "../Containers/SocialContainer"
import ProgramQuestionsContainer from "../Containers/ProgramQuestionsContainer"
import FollowUpContainer from "../Containers/FollowUpContainer"
import DischargeContainer from "../Containers/DischargeContainer"
import ServicesReceived1Container from "../Containers/ServicesReceived1Container"
import ServicesReceived2Container from "../Containers/ServicesReceived2Container"
import ServicesReceived3Container from "../Containers/ServicesReceived3Container"
import ServicesReceived4Container from "../Containers/ServicesReceived4Container"
import ServicesReceived5Container from "../Containers/ServicesReceived5Container"
import { Button } from "primereact/button"
import axios from "axios"
import { useState } from "react"
import { endpoints } from "../../../config/gpraApiEndpoints"
import { gpraUrl } from "../../../config/microservicesUrls"
import { useContext } from "react"
import { UserContext } from "../../../context/userContext"
import { saveAs } from "file-saver"
import { showMessage } from "../utils/utils"
import { errorMessages } from "../types/messages"
import { useRef } from "react"

const GpraHistorySummary = ({ gpra_interview_id, interview_type }) => {
  const [loading, setLoading] = useState(false)
  const userCtx = useContext(UserContext)
  const toast = useRef()

  const download = () => {
    setLoading(true)
    axios({
      method: "get",
      url: `${gpraUrl()}${endpoints.GET_PDF}`,
      responseType: "blob",
      params: {
        gpra_participant_uuid: userCtx.participant_id,
        interview_type: interview_type,
        membership_uuid: userCtx.participant_membership_id,
        organization_uuid: userCtx.session.user.organization_id,
      },
      headers: { Authorization: `Bearer ${userCtx.tokenGpra}` },
    })
      .then((response) => {
        if (response.status !== 500) {
          var file = new File(
            [response.data],
            `${userCtx.participant_id}.pdf`,
            {
              type: "application/pdf;charset=utf-8",
            }
          )
          setLoading(false)
          saveAs(file)
        } else {
          setLoading(false)
          showMessage(false, errorMessages.pdfError, toast)
        }
      })
      .catch(() => {
        setLoading(false)
        showMessage(false, errorMessages.pdfError, toast)
      })
  }
  return (
    <>
      <div
        style={{ display: "flex", justifyContent: "end", marginBottom: "1rem" }}
      >
        <Button
          label="Download"
          icon={!loading ? "pi pi-download" : "pi pi-spin pi-spinner"}
          disabled={loading}
          onClick={() => {
            download()
          }}
        />
      </div>
      <Accordion>
        {interview_type === INTERVIEW_TYPES.INTAKE && (
          <AccordionTab header="A. Demographics">
            <DemographicsContainer
              showToolBar={false}
              disabled
              interview_id={gpra_interview_id}
            />
          </AccordionTab>
        )}
        {interview_type === INTERVIEW_TYPES.INTAKE && (
          <AccordionTab header="B. Planned Services">
            <PlannedServices1Container
              showToolBar={false}
              disabled
              interview_id={gpra_interview_id}
            />
            <PlannedServices2Container
              showToolBar={false}
              disabled
              interview_id={gpra_interview_id}
            />
            <PlannedServices3Container
              showToolBar={false}
              disabled
              interview_id={gpra_interview_id}
            />
            <PlannedServices4Container
              showToolBar={false}
              disabled
              interview_id={gpra_interview_id}
            />
          </AccordionTab>
        )}
        <AccordionTab header="B. Substance Use">
          <SubstanceUse1Container
            showToolBar={false}
            disabled
            interview_id={gpra_interview_id}
          />
          <SubstanceUse2Container
            showToolBar={false}
            disabled
            interview_id={gpra_interview_id}
          />
          <SubstanceUse3Container
            showToolBar={false}
            disabled
            interview_id={gpra_interview_id}
          />
        </AccordionTab>
        <AccordionTab header="C. Family">
          <FamilyContainer
            showToolBar={false}
            disabled
            interview_id={gpra_interview_id}
          />
        </AccordionTab>
        <AccordionTab header="D. Education">
          <EducationContainer
            showToolBar={false}
            disabled
            interview_id={gpra_interview_id}
          />
        </AccordionTab>
        <AccordionTab header="E. Legal">
          <LegalContainer
            showToolBar={false}
            disabled
            interview_id={gpra_interview_id}
          />
        </AccordionTab>
        <AccordionTab header="F. Mental">
          <MentalContainer
            showToolBar={false}
            disabled
            interview_id={gpra_interview_id}
          />
        </AccordionTab>
        <AccordionTab header="G. Social">
          <SocialContainer
            showToolBar={false}
            disabled
            interview_id={gpra_interview_id}
          />
        </AccordionTab>
        {interview_type === INTERVIEW_TYPES.FOLLOW_UP ||
          (interview_type === INTERVIEW_TYPES.DISCHARGE && (
            <AccordionTab header="H. Program Questions">
              <ProgramQuestionsContainer
                showToolBar={false}
                disabled
                interview_id={gpra_interview_id}
              />
            </AccordionTab>
          ))}
        {interview_type === INTERVIEW_TYPES.FOLLOW_UP && (
          <AccordionTab header="I. Follow Up">
            <FollowUpContainer
              showToolBar={false}
              disabled
              interview_id={gpra_interview_id}
            />
          </AccordionTab>
        )}
        {interview_type === INTERVIEW_TYPES.DISCHARGE && (
          <AccordionTab header="J. Discharge">
            <DischargeContainer
              showToolBar={false}
              disabled
              interview_id={gpra_interview_id}
            />
          </AccordionTab>
        )}
        {interview_type === INTERVIEW_TYPES.DISCHARGE && (
          <AccordionTab header="K. Services Received">
            <ServicesReceived1Container
              showToolBar={false}
              disabled
              interview_id={gpra_interview_id}
            />
            <ServicesReceived2Container
              showToolBar={false}
              disabled
              interview_id={gpra_interview_id}
            />
            <ServicesReceived3Container
              showToolBar={false}
              disabled
              interview_id={gpra_interview_id}
            />
            <ServicesReceived4Container
              showToolBar={false}
              disabled
              interview_id={gpra_interview_id}
            />
            <ServicesReceived5Container
              showToolBar={false}
              disabled
              interview_id={gpra_interview_id}
            />
          </AccordionTab>
        )}
      </Accordion>
    </>
  )
}
export default GpraHistorySummary
